<template>
  <div
    v-if="event.event_status === 'soldout'"
    class="flex items-center ml-auto space-x-1 text-red-700 text-sm bg-red-50 px-3 py-1 rounded-full">
    <div class="w-2 h-2 bg-red-600 rounded-full"></div>
    <span>{{ $t("Out of stock") }}</span>
  </div>

  <div
    v-else-if="event.event_status === 'nosale'"
    class="flex items-center ml-auto space-x-1 text-info-muted-foreground text-sm bg-info-muted px-3 py-1 rounded-full">
    <div class="w-2 h-2 bg-info-muted-foreground rounded-full"></div>
    <span>{{ $t("Coming soon") }}</span>
  </div>

  <div
    v-else-if="event.event_status === 'cancelled'"
    class="flex items-center ml-auto space-x-1 text-red-700 text-sm bg-red-50 px-3 py-1 rounded-full">
    <div class="w-2 h-2 bg-red-600 rounded-full"></div>
    <span>{{ $t("N/A") }}</span>
  </div>

  <div
    v-else-if="event.event_status === 'notstarted'"
    class="flex items-center mt-auto space-x-1 text-green-600 text-sm bg-green-50 px-3 py-1 rounded-full">
    <div class="w-2 h-2 bg-green-600 rounded-full"></div>
    <span>{{ $t("In stock") }}</span>
  </div>
</template>

<script setup lang="ts">
// eslint-disable-next-line @typescript-eslint/no-explicit-any
defineProps<{ event: any }>();
</script>
